import _ from 'lodash'

export default {
    methods: {
        /**
         *
         * @returns promise
         */
        async cookie() {
            if (this.$store.state.cookie === '') {
                const cookie = await this.cookieFromAPI()

                if (cookie && "encryptedSessionKey" in cookie) {
                    this.$store.commit('tnewCookie', cookie)
                } else {
                    throw new Error('Could not locate cookie in response from TNEW API.')
                }
            }

            return this.$store.state.cookie
        },

        /**
         *
         * @returns promise
         */
        async cookieFromAPI() {
            return await fetch(`${window.env.TNEW_BASE_URL}/api/session/sessionkey`, {
                credentials: 'include'
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        throw new Error('Could not fetch cookie from TNEW API.')
                    }
                })
                .catch(error => console.log(error))
        },

        /**
         *
         * @returns promise
         */
        async cookieFromServer() {
            return await fetch(`${window.env.API_BASE_URL}/api/v1/session/`)
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        throw new Error('Could not fetch cookie from remote server.')
                    }
                })
                .catch(error => console.log(error))
        },

        /**
         *
         * @param {int} modeOfSaleId
         * @returns
         */
        async modeOfSale(modeOfSaleId) {
            const cookie = await this.cookie().then(json => json)
            return await fetch(`${window.env.TESS_BASE_URL}/modeofsale`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify({
                    encryptedSessionKey: btoa(cookie.encryptedSessionKey),
                    modeOfSaleId: modeOfSaleId
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        throw new Error('Could not update mode of sale.')
                    }
                })
                .catch(error => console.log(error))
        },

        /**
         *
         * @param {string} promoCode
         * @returns
         */
        async promoCode(promoCode) {
            const cookie = await this.cookie().then(json => json)
            return await fetch(`${window.env.TESS_BASE_URL}/promocode`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify({
                    encryptedSessionKey: btoa(cookie.encryptedSessionKey),
                    promoCode: promoCode
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        throw new Error('Could not update promo code.')
                    }
                })
                .catch(error => console.log(error))
        },

        /**
         * Return details about the current user's session
         * @returns promise
         */
        async session() {
            const cookie = await this.cookie().then(json => json)
            if (cookie.encryptedSessionKey) {
                return await fetch(`${window.env.TESS_BASE_URL}/sessionkey`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        encryptedSessionKey: btoa(cookie.encryptedSessionKey)
                    })
                })
                    .then(response => {
                        if (response.ok) {
                            return response.json()
                        } else {
                            throw new Error('Could not fetch session from Tessitura API.')
                        }
                    })
                    .catch(error => console.log(error))
            }
        },

    }
}
